import { render, staticRenderFns } from "./Parceria_SinteepRO.vue?vue&type=template&id=33e9b43a"
import script from "./Parceria_SinteepRO.vue?vue&type=script&lang=js"
export * from "./Parceria_SinteepRO.vue?vue&type=script&lang=js"
import style0 from "./Parceria_SinteepRO.vue?vue&type=style&index=0&id=33e9b43a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports